import { forwardRef, useEffect, useState } from "react";
import { Container } from "../components/Layout/Container";
import { Section } from "../components/Layout/Section";

import { useApp } from "../AppProvider";
import { collection, getDocs } from "@firebase/firestore";
import TeamItems from "../components/Team/TeamItems";
import TeamItem, { TeamItemProps } from "../components/Team/TeamItem";
import TeamPlaceholder from "../components/Team/TeamPlaceholder";
import SectionTitle from "../components/SectionTitle";

type Props = {
  handleKontaktformular: () => void;
};

export const Team = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const [team, setTeam] = useState<TeamItemProps[]>([]);
  const { cookiesAccepted, db } = useApp();

  useEffect(() => {
    let cancel = false;

    if (cookiesAccepted === undefined || !db) {
      return;
    }

    getDocs(collection(db, "team"))
      .then((querySnapshot) => {
        const team: TeamItemProps[] = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data() as TeamItemProps;
          data.id = doc.id;
          team.push(data);
        });
        if (!cancel) {
          setTeam(
            team.sort((a, b) => {
              return a.order - b.order;
            })
          );
        }
      })
      .catch((error) => console.log(error.message));

    return () => {
      cancel = true;
    };
  }, [cookiesAccepted, db]);

  return (
    <Section ref={ref}>
      <Container>
        <SectionTitle>TEAM</SectionTitle>
        <TeamItems>
          {team.map((member) => (
            <TeamItem {...member} key={member.id} />
          ))}
          <TeamPlaceholder
            handleKontaktformular={props.handleKontaktformular}
          />
        </TeamItems>
      </Container>
    </Section>
  );
});
